export default {
  'welcome.title': 'Welcome to',
  'welcome.sub': 'Starbucks® Rewards',
  'welcome.text.content1':
    'Verify your email address to get started! A verification link has been sent to your registered email address, click on the link to activate your account and complete the registration.',
  'welcome.text.content2':
    'If you do not receive the email within the next few minutes, please check your junk/spam folder.',
  'welcome.text.signIn': 'Sign in',
};
